import React, {Component} from 'react';
import CardWidget from "../card-widget/CardWidget";
import {RouteConstants} from "../route/services/RouteConstants";
import CardWidgetContent from "../card-widget/CardWidgetContent";
import Api from "../../services/api/Api";
import { getLanguage } from "../../store/rootReducer";
import {ApiPaths} from "../../services/api/ApiPaths";
import {connect} from "react-redux";

class IncompleteRegistrationSection extends Component {

    sendCompleteRegistrationEmail = () => {
        let email = this.props.location.state.email;

        if(email){
            let request = {"email": email, "lang": this.props.language};
            Api.post(ApiPaths.SEND_COMPLETE_REGISTRATION_REQUEST_EMAIL, request).then(
                (response) => {
                    this.props.history.push(RouteConstants.COMPLETE_REGISTRATION_REQUEST_EMAIL_SENT);
                },
                (error) => {
                    this.setState({
                        errorMessage: "common.general_processing_error"
                    });
                }
            )
        }else{
            this.props.history.push(RouteConstants.LOGIN);
        }

    };

    goToLoginScreen = () => {
        this.props.history.push(RouteConstants.LOGIN);
    };


    getIncompleteRegistrationSectionContent = () => {
        return (
            <CardWidgetContent contentText="incomplete_registration.incomplete_registration_desc"/>
        )
    };

    render() {
        return (
            <CardWidget
                getCardContent={this.getIncompleteRegistrationSectionContent}
                submitButtonAction={this.sendCompleteRegistrationEmail}
                submitButtonText="incomplete_registration.send_email"
                cancelButtonAction={this.goToLoginScreen}
                cancelButtonText="incomplete_registration.cancel"
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        language: getLanguage(state)
    };
};


export default connect(mapStateToProps) (IncompleteRegistrationSection);